import { injectIntl } from 'react-intl'
import 'styles/app/inner-layout.scss'
import ListFromTable from 'components/common/ListFromTable'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import messages from './translate'

class TranslationsLayout extends ListFromTable {
  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.translationList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: false,
      creating: false,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()

    columns.add(
      new Column('name', formatMessage(messages.name), {
        sorting: true,
        render: rowData => rowData.alt,
      }),
    )

    return columns
  }

  getActions() {
    const {
      intl: { formatMessage },
      history,
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action('arrow_forward', formatMessage(messages.edit), row => {
        history.push(row.path)
      }),
    )

    return actions
  }
}

export default injectIntl(TranslationsLayout)
